var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "text-h5 q-mt-lg q-mb-md" }, [
        _vm._v(_vm._s(_vm.$t(_vm.game_data.game_name)))
      ]),
      _c(
        "q-collapsible",
        {
          staticClass: "shadow-2 q-pa-sm q-ma-xs rounded-border",
          attrs: {
            icon: "far fa-check-square",
            "right-icon": "far fa-check-square",
            label: _vm.$t("how_to_create_the_game")
          }
        },
        [
          _c("div", { staticClass: "q-ma-sm" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("find_the_words_instructions")))]),
            _c("p", { staticClass: "text-bold" }, [
              _vm._v(_vm._s(_vm.$t("example")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("find_the_words_instructions_example")))
            ]),
            _c("p", { staticClass: "q-mt-lg" }, [
              _c("em", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("warning") + ":"))]),
                _vm._v(_vm._s(_vm.$t("create_game_before_save")))
              ])
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 text-center q-mt-md" },
          [
            _c("q-icon", {
              staticStyle: { "font-size": "3em" },
              attrs: { name: "fas fa-hard-hat", size: "xl" }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }